var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fixed--btn",class:_vm.customCss},[_vm._t("default",[_c('button',{class:[_vm.variant]},[_c('span',{staticClass:"material-icons material-icons-outlined"},[_vm._v(" add ")])])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }